import fetch from "auth/FetchInterceptor";

const TutorialsService = {};
const tutorialsPrefix = "/tutorials";

TutorialsService.getTutorials = async () =>
  await fetch(`${tutorialsPrefix}`, {
    method: "GET",
  });

TutorialsService.getTutorialById = async (id) =>
  await fetch(`${tutorialsPrefix}/${id}`, {
    method: "GET",
  });

TutorialsService.createTutorial = async (data) =>
  await fetch(`${tutorialsPrefix}`, {
    method: "POST",
    data,
    timeout: 600000,
  });

TutorialsService.updateTutorial = async (id, data) =>
  await fetch(`${tutorialsPrefix}/${id}`, {
    method: "PATCH",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

TutorialsService.deleteTutorialById = async (id) =>
  await fetch(`${tutorialsPrefix}/${id}`, {
    method: "DELETE",
  });

TutorialsService.changeStatus = async (id, status) =>
  await fetch(`${tutorialsPrefix}/${id}/status`, {
    method: "PATCH",
    data: { status },
  });

TutorialsService.changeVisibility = async (id, visibility) =>
  await fetch(`${tutorialsPrefix}/${id}/visibility`, {
    method: "PATCH",
    data: { visibility },
  });

TutorialsService.validateTutorial = async (id) =>
  await fetch(`${tutorialsPrefix}/${id}/validate`, {
    method: "PATCH",
  });

TutorialsService.rejectTutorial = async (id, reason) =>
  await fetch(`${tutorialsPrefix}/${id}/reject`, {
    method: "PATCH",
    data: { reason },
  });

// Assignation dédiée : JSON (et non multipart comme la création / l'update)
// L'ancien enseignant est retiré automatiquement.
TutorialsService.assignInstructor = async (id, instructorId) =>
  await fetch(`${tutorialsPrefix}/${id}/instructor`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    data: { instructorId },
  });

TutorialsService.addStudentToTutorial = async (id, data) =>
  await fetch(`${tutorialsPrefix}/${id}/students`, {
    method: "POST",
    data,
  });

export default TutorialsService;
